// src/modules/useInstantRefresh.js
import { useEffect } from "react";

/**
 * useInstantRefresh
 * -----------------
 * React hook that listens for hymn creation or update events
 * and triggers a callback to refresh hymn data in real time.
 *
 * Usage:
 *   useInstantRefresh(() => loadHymns());
 */
export default function useInstantRefresh(onRefresh) {
  useEffect(() => {
    if (typeof onRefresh !== "function") return;

    const handleRefresh = (e) => {
      console.debug("🔁 Refresh triggered:", e.detail);
      onRefresh();
    };

    window.addEventListener("hymn:created", handleRefresh);
    window.addEventListener("hymn:updated", handleRefresh);

    return () => {
      window.removeEventListener("hymn:created", handleRefresh);
      window.removeEventListener("hymn:updated", handleRefresh);
    };
  }, [onRefresh]);
}
